import Api from '../../../../shared/Api';

class OrderCollectionApi {
    static view(id: number): any {
        return new Api().get(`/views/ordercollections/${id}`);
    }

    static updateOrderCollectionName(id: number, name: string): any {
        return new Api().put(`/views/ordercollections/${id}/name`, {
            orderCollectionName: name,
            orderCollectionId: id
        });
    }
}

export default OrderCollectionApi;
